var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('button',{on:{"click":_vm.changeTitle}},[_vm._v("제목 변경")]),_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item},[_vm._v(_vm._s(item))])}),0),_c('button',{on:{"click":_vm.addItem}},[_vm._v("아이템 추가")])])
}
var staticRenderFns = []

export { render, staticRenderFns }